import {
  dataStataus,
  ROLE_ADMIN,
  ROLE_COUNTRY,
  ROLE_PROVINCE,
  ROLE_CITY,
  ROLE_AREA,
  ROLE_SCHOOL
} from './common';
import { Dialog } from 'vant';
import { viceCounselorList, buildingTeamList, concurrentCoursesList, organizerList, trainLevelList, batchTeamList, eduList, sexs, schoolTypes, postTypeList, administrationList, yORn, zzmmList, zzmmList01, jobList, titleList, sgwJobList, levelJobList, companyList, eventScheduleList } from './field';

export const tipsMsg = (title, message, cbFn) => {
  Dialog.alert({
    title,
    message,
    confirmButtonColor: '#0e97f9'
  }).then(() => {
    Dialog.close()
    cbFn && cbFn();
  });
};

export const getLocal = (name) => {
  return localStorage.getItem(name)
}

export const setLocal = (name, value) => {
  localStorage.setItem(name, value)
}

export const clearLocal = (name) => {
  localStorage.removeItem(name)
}
export const logoutClear = () => {
  clearLocal("dsj_modifyPwd");
  clearLocal("dsj_accessToken")
  clearLocal("dsj_roleId")
  clearLocal("dsj_store")
  clearLocal("dsj_school")
  clearLocal("dsj_profileExists")
  clearLocal("dsj_area")
}
export const getStatusName = (val) => {
  const state = dataStataus.filter(item => {
    return item.status === val
  })
  if (state.length > 0) {
    return state[0];
  } else {
    return '';
  }
}
export const getRadioValue = (i, values) => {
  if (values !== '') {
    let arr = values.split(',');
    const val = arr[i];
    return parseInt(val);
  } else {
    return 0;
  }
};
export const getRoleId = async () => {
  let role = await getLocal("dsj_roleId");
  role = Number(role);
  return role;
}
export const getRole = async () => {
  let role = await getLocal("dsj_roleId");
  role = Number(role);
  let flag = false;
  switch (role) {
    case ROLE_ADMIN:
    case ROLE_COUNTRY:
    case ROLE_PROVINCE:
    case ROLE_CITY:
    case ROLE_AREA:
      flag = true;
      break;
    case ROLE_SCHOOL:
      flag = false;
      break;

  }
  return flag;
}
export const ROLE_NAME = (role) => {
  let name = "";
  switch (role) {
    case ROLE_ADMIN:
      name = " 超级管理员";
      break;
    case ROLE_COUNTRY:
      name = "全国";
      break;
    case ROLE_PROVINCE:
      name = "省";
      break;
    case ROLE_CITY:
      name = "市";
      break;
    case ROLE_AREA:
      name = "区";
      break;
    case ROLE_SCHOOL:
      name = "学校";
      break;
  }
  return name;
}
// DISABLED(0,"已禁用"),ENABLED(1,"正常"),AUDIT_PWD(-1,"申请找回密码");
export const statusClass = (status) => {
  let sClass = '';
  switch (status) {
    case -1:
      sClass = 'btn5_2'
      break;
    case 0:
      sClass = 'btn5_3'
      break;
    case 1:
      sClass = 'btn5_1'
      break;
  }
  return sClass;
}
export const unixTimeToDateTime = (unixtime) => {
  let now = new Date(unixtime * 1000); // 依情况进行更改 * 1
  let y = now.getFullYear();
  let m = now.getMonth() + 1;
  let d = now.getDate();
  return y + "-" + (m < 10 ? "0" + m : m) + "-" + (d < 10 ? "0" + d : d) + " " + now.toTimeString().substr(0, 8);
}

export const formatDateFN = (time) => {
  if(time == "") return "";
  var date = new Date(parseInt(time * 1000));
  var year = date.getFullYear();
  var mon = date.getMonth() + 1;
  // var day = date.getDate();
  // return year+'/'+mon+'/'+day;
  return year + '年' + mon + '月';
};

export const formatDateYMD = (time) => {
  var date = new Date(parseInt(time * 1000));
  var year = date.getFullYear();
  var mon = date.getMonth() + 1;
  var day = date.getDate();
  // return year+'/'+mon+'/'+day;
  return year + '-' + mon + '-' + day;
};

export const formatFn = (value, list) => {
  let result = list.filter((res) => res.key == value);
  if (result.length > 0) {
    return result[0].value;
  }
  return "";
}

/**
 * 
 * @param {*} value 
 * @param {*} type 
 * 1 是否
 * 2 政治面貌
 * 3 校内职务
 * 4 职称
 * 5 少工委职务
 * 6 格式化日期
 * 7 本级少工委职务
 * 8 编制所在单位
 * 9 岗位类型
 * 10 行政级别
 * 11 学校类型
 * 12 男女
 * 13 学历
 * 14 批次入队
 * 15 培训级别
 * 
 * 18 学校是否建队
 * 
 * 19 副大队辅导员人数
 * 
 * @returns 
 */
export const format = (value, type) => {
  let txt = "";

  switch (type) {
    case 1:
      txt = formatFn(value, yORn);
      break;
    case 2:
      txt = formatFn(value, zzmmList);
      break;
    case 3:
      txt = formatFn(value, jobList);
      break;
    case 4:
      txt = formatFn(value, titleList);
      break;
    case 5:
      txt = formatFn(value, sgwJobList);
      break;
    case 6:
      txt = formatDateFN(value);
      break;
    case 7:
      txt = formatFn(value, levelJobList);
      break;
    case 8:
      txt = formatFn(value, companyList);
      break;
    case 9:
      txt = formatFn(value, administrationList);
      break;
    case 10:
      txt = formatFn(value, postTypeList);
      break;
    case 11:
      txt = formatFn(value, schoolTypes);
      break;
    case 12:
      txt = formatFn(value, sexs);
      break;
    case 13:
      txt = formatFn(value, eduList);
      break;
    case 14:
      txt = formatFn(value, batchTeamList);
      break;
    case 15:
      txt = formatFn(value, trainLevelList);
      break;
    case 16:
      txt = formatFn(value, organizerList);
      break;
    case 17:
      txt = formatFn(value, concurrentCoursesList);
      break;
    case 18:
      txt = formatFn(value, buildingTeamList);
      break;
    case 19:
      txt = formatFn(value, viceCounselorList);
      break;
    case 20:
      txt = formatFn(value, eventScheduleList);
      break;
    case 21:
      txt = formatFn(value, zzmmList01);
      break;
    case 22:
      txt = formatDateYMD(value);
      break;
  }
  return txt;
};

export const radioChange = (event, vmodel, cb) => {
  if (vmodel) {
    cb(event)
  }
}
// 校验函数返回 true 表示校验通过，false 表示不通过
export const validator = (val) => {
  if (val <= 0) {
    return false
  }
  return true
}

export const validatorMax = (val) => {
  const intValue = parseInt(val, 10);
  console.log('intValue--', intValue)
  if (isNaN(intValue) || intValue < 0 || intValue > 99) {
    return false
  }
  return true
}

// 校验函数返回 true 表示校验通过，false 表示不通过
export const validatorNum = (val) => {
  if (val <= 0 || val > 10000) {
    return false
  }
  return true
}

// 根据日期计算天数 日期范围 type: 1 包含首尾，2 不包含
export const dateDiff = (sDate1, sDate2,  type = 2) => {
  let iDays; //  oDate1, oDate2,
  // oDate1 = new Date(
  //   sDate1.substring(4, 6) + "-" + sDate1.substring(6) + "-" + sDate1.substring(0, 4)
  // );
  // console.log('oDate1', oDate1)
  // oDate2 = new Date(
  //   sDate2.substring(4, 6) + "-" + sDate2.substring(6) + "-" + sDate2.substring(0, 4)
  // );

  iDays = parseInt(Math.abs(sDate1 - sDate2) / 1000 / 60 / 60 / 24);
  if(type == 1) {
    iDays += 1
  }

  return iDays;
};
export const formatDate = (date) => {
  let y = date.getFullYear()
  let m = date.getMonth() + 1
  let d = date.getDate()
  if(m<10) {
    m = '0' + m
  }
  if(d<10) {
    d = '0' + d
  }
  return `${y}-${m}-${d}`;
};

export const formatIdByTxt = (arr, key) => {
  let txt = "请选择";
  if (arr.length == 0) return txt;
  let f = arr.filter((res) => res.key == key);
  if (f.length > 0) {
    txt = f[0].value;
  }
  return txt;
};